"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
// eslint-disable-next-line import/prefer-default-export
exports.setBackgroundConfig = function (config) {
    return toolkit_1.createAction(constants_1.SET_BACKGROUND_IMAGE_CONFIG)(config);
};
//# sourceMappingURL=actions.js.map